import React, { useState, useEffect } from 'react';
import SmoothPageTransition from './SmoothPageTransition/SmoothPageTransition';
import ScreenLoader from './ScreenLoader/ScreenLoader';

/**
 * Wrapper komponentu z obsługą przejść między stronami
 * @param {object} props - Props przekazywane do komponentu
 * @param {boolean} props.showLoader - Czy pokazywać wskaźnik ładowania
 * @returns {JSX.Element} - Opakowany komponent z obsługą płynnych przejść
 */
const PageTransitionWrapper = ({ children, showLoader = false }) => {
  // Stan dla opóźnionego pokazania loadera
  const [showDelayedLoader, setShowDelayedLoader] = useState(false);
  
  // Pokaż loader tylko jeśli ładowanie trwa dłużej niż 300ms
  useEffect(() => {
    let timer;
    if (showLoader) {
      timer = setTimeout(() => {
        setShowDelayedLoader(true);
      }, 300); // Opóźnienie 300ms
    } else {
      setShowDelayedLoader(false);
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [showLoader]);
  
  // Wskaźnik ładowania z warunkiem
  const loadingIndicator = showDelayedLoader ? <ScreenLoader /> : null;

  return (
    <SmoothPageTransition loadingIndicator={loadingIndicator}>
      {children}
    </SmoothPageTransition>
  );
};

export default PageTransitionWrapper;